import { HelpArea } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.types';
import './style.less';

import imageStandard from '@/assets/images/home_banner.png';
import { Skeleton } from 'antd';

interface HelpCenterBannerProps {
  loading?: boolean;
  title?: string;
  background?: 'HOME' | 'CODE' | 'MANAGE' | 'DATA';
  helpArea?: HelpArea;
}

function HelpCenterBanner({ helpArea, loading }: HelpCenterBannerProps) {
  return (
    <div className="hc-banner-wrapper">
      <Skeleton loading={loading}>
        <img src={helpArea?.banner ?? imageStandard} alt="banner" />
      </Skeleton>
    </div>
  );
}

export default HelpCenterBanner;
